import { Controller } from "@hotwired/stimulus"
import debounce from "lodash.debounce";

// Connects to data-controller="content-search"
export default class extends Controller {
  static targets = ["input", "list", "type", "form"]
  static values = { suggestUrl: String, enabled: Boolean }

  initialize() {
    this.fetchSuggestions = debounce(this.fetchSuggestions.bind(this), 300)
  }

  onInput(event) {
    const value = event.target.value.trim()
    this.typeTarget.value = ""

    if (!this.enabledValue) {
      this.clearList()
      this.closeDropdown()
      return
    }

    if (value.length < 3) {
      this.clearList()
      this.closeDropdown()
      return
    }

    this.fetchSuggestions(value)
  }

  onFocus() {
    if (!this.enabledValue) {
      return
    }

    if (this.listTarget.children.length > 0) {
      this.openDropdown()
    }
  }

  onSubmit(event) {
    const value = this.inputTarget.value.trim()
    if (value.length < 3) {
      event.preventDefault()
      this.clearList()
      this.closeDropdown()
    }
  }

  closeIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.closeDropdown()
    }
  }

  async fetchSuggestions(query) {
    const url = new URL(this.suggestUrlValue, window.location.origin)
    url.searchParams.set("term", query)

    try {
      const response = await fetch(url.toString(), {
        headers: { Accept: "application/json" }
      })

      if (!response.ok) {
        this.clearList()
        this.closeDropdown()
        return
      }

      const results = await response.json()
      this.renderSuggestions(results)
    } catch (error) {
      this.clearList()
      this.closeDropdown()
    }
  }

  renderSuggestions(results) {
    this.clearList()

    if (!Array.isArray(results) || results.length === 0) {
      this.closeDropdown()
      return
    }

    results.forEach((result) => {
      const term = result.term || ""
      const type = result.type || ""
      const item = document.createElement("li")

      item.className = "group relative cursor-default select-none py-2 pl-3 pr-4 text-gray-900 hover:text-white hover:bg-indigo-600"
      item.dataset.action = "click->content-search#selectSuggestion"
      item.dataset.term = term
      item.dataset.type = type

      const row = document.createElement("div")
      row.className = "flex items-center justify-between"

      const termSpan = document.createElement("span")
      termSpan.className = "truncate"
      termSpan.textContent = term

      const typeSpan = document.createElement("span")
      typeSpan.className = "ml-3 truncate text-xs uppercase text-gray-400 group-hover:text-white/70"
      typeSpan.textContent = type.replace(/_/g, " ")

      row.appendChild(termSpan)
      row.appendChild(typeSpan)
      item.appendChild(row)
      this.listTarget.appendChild(item)
    })

    this.openDropdown()
  }

  selectSuggestion(event) {
    event.preventDefault()
    const { term, type } = event.currentTarget.dataset

    this.inputTarget.value = term
    this.typeTarget.value = type || ""

    this.closeDropdown()
    this.formTarget.requestSubmit()
  }

  clearList() {
    this.listTarget.innerHTML = ""
  }

  openDropdown() {
    this.listTarget.classList.remove("animate-dropdown-close")
    this.listTarget.classList.add("animate-dropdown-open")
    this.listTarget.dataset.stateValue = "true"
  }

  closeDropdown() {
    this.listTarget.classList.remove("animate-dropdown-open")
    this.listTarget.classList.add("animate-dropdown-close")
    this.listTarget.dataset.stateValue = "false"
  }
}
